export default __webpack_public_path__ + "static/media/netlify-icon.74b0c6a7.svg";